import { Link, useIntl } from '@umijs/max';
import { Button, Card, Result } from 'antd';

/** 无权限访问时展示（由 layout unAccessible 使用，也可通过路由直链） */
export default () => {
  const intl = useIntl();
  return (
    <Card variant="borderless">
      <Result
        status="403"
        title="403"
        subTitle={intl.formatMessage({ id: '页面.403.无权限' })}
        extra={
          <Link to="/">
            <Button type="primary">{intl.formatMessage({ id: '页面.403.返回首页' })}</Button>
          </Link>
        }
      />
    </Card>
  );
};
